import { HelpersService } from './../../services/tools/helpers.service';
import { AutenticacionService } from './../../services/autenticacion.service';
import { ValidatorService } from '../../services/tools/validator.service';
import { ObrasService } from '../../services/obras.service';
import { CuentasService } from '../../services/cuentas.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from '../tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../tools/modals/confirm-modal/confirm-modal.component';
import { WarningModalComponent } from '../tools/modals/warning-modal/warning-modal.component';
import { SecurityModalComponent } from './../partials/security-modal/security-modal.component';
import {Globals} from './../../services/tools/Globals.service';
declare var $;

@Component({
  selector: 'app-catalogo-cuentas',
  templateUrl: './catalogo-cuentas.component.html',
  styleUrls: ['./catalogo-cuentas.component.scss']
})
export class CatalogoCuentasComponent implements OnInit {

  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;
  @ViewChild(WarningModalComponent) warningModal: WarningModalComponent;
  @ViewChild(SecurityModalComponent) securityModal: SecurityModalComponent;

  obras:any[];
  cuentas:any[];
  searchText:string = "";
  cuentaSelected:any;
  mostrarListado:boolean = true;
  errors:any = {};
  searchProcess:any;
  tiposCuentas:any = {};
  paginate:any = {};
  filterByObra:any;
  currentPage: any = 1;
  lastPage: any = 1;
  processing:any = false;
  alterTable:any = 'starting';
  exporting: any = false;
  securityActived: any = false;

  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;

  constructor(private cuentasService: CuentasService, private obrasService: ObrasService, private validatorService: ValidatorService, private authService: AutenticacionService, private helperService: HelpersService, private globals: Globals){
    // se colocó esto para que el this dentro de delete sea el del scope global
    this.deleteCuenta = this.deleteCuenta.bind(this);
    this.resetCuentaSelected = this.resetCuentaSelected.bind(this);
    this.tiposCuentas = this.cuentasService.getCuentasTipos(this.securityActived);
    this.getCuentas();
    this.getObras();

   }

  ngOnInit() {
    this.globals.passwordActivate = false;
  }

  pageChanged(event: any): void {
    if(event.page !== undefined)
      if(event.page != this.page)
      {  
        this.page = event.page;
      }
    this.goPage(this.page);
  }

  filtrarCuentas() {
    this.goPage(1);
  }

  resetCuentaSelected(){
    this.cuentaSelected = undefined;
    this.errors = {};
  }

  startCuentaSelected(){
    this.resetCuentaSelected();
    this.cuentaSelected = this.cuentasService.getDefaultSchedule();
  }

  selectCuenta(cuenta){
    this.resetCuentaSelected();
    this.cuentaSelected = cuenta;
  }

  SelectedCuentaClass(cuenta){
    return (this.validatorService.required(this.cuentaSelected) && this.cuentaSelected.idCuentas == cuenta.idCuentas)?"active":"";
  }

  getCuentaTipoNombre(id){
    if (!id) {
      return "";
    }
    const cuenta = this.cuentasService.getCuentaTipo(id, this.securityActived);
    return (cuenta)? cuenta.nombre : "";
  }

  confirmDeleteCuenta(){
    this.confirmModal.open({
      'title': 'Eliminar obra',
      'description': '¿Está seguro que desea eliminar esta Obra?',
      'callback': this.deleteCuenta
    });
  }

  deleteCuenta(){
    this.processing = true;
    this.cuentasService.deleteCuenta(this.cuentaSelected.idCuentas)
      .subscribe(
        response => {
          this.processing = false;
          this.successModal.open({
            'title': '¡Éxito!',
            'description': 'Se ha eliminado correctamente la cuenta seleccionada'
          });

          this.getCuentas();
      },error => {
        this.processing = false;

        // resolviendo errores 403 y 500. sin notifications
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400 || error.status == 500) {
          this.errorModal.open({
            'title': 'Error',
            'description': 'Ha ocurrido un error al intentar eliminar el concepto, inténtelo más tarde'
          });
        }
      });
  }

  searchCuentas(page = null){
    console.log('searching');
    if (this.searchProcess){
      this.searchProcess.unsubscribe();
    }

    if (this.searchText.length > 1){
      this.searchProcess = this.cuentasService.searchCuentas(this.searchText, page, this.filterByObra)
          .subscribe(response => {
            let content = response.json().content;
            this.cuentas = content.data;
            this.searchProcess = false;
            this.startPaginate(content);
            this.alterTable = (this.cuentas.length > 0)? false: 'not_found';
          }, (error) => {
            // resolviendo errores 403 y 500. sin notifications
            this.helperService.httpGlobalError(error, false);
          });
    } else {
      this.getCuentas();
    }
  }

  getCuentas(page = null){
    console.log('getting');
    this.searchProcess = this.cuentasService.getCuentas(page, this.filterByObra)
      .subscribe(response => {
        let content = response.json().content;

        console.log('content ', content);

        this.cuentas = content.data;
        this.startPaginate(content);
        this.searchProcess = false;
        const result_text = (this.filterByObra)? 'not_found': 'not_result';
        this.alterTable = (this.cuentas.length > 0)? false: result_text; // se muestra mensaje si no se encuentran registros
      }, (error) => {
        // resolviendo errores 403 y 500. sin notifications
        this.helperService.httpGlobalError(error);
      });
  }

  getObras(){
    this.obrasService.getObras()
    .subscribe(response => {
      const content = response.json().content;
      this.obras = content;
    });
  }
  
  createCuenta() {
    this.errors = [];
    if(this.cuentaSelected.saldoActual === "")
      this.cuentaSelected.saldoActual = "0.0";
    this.errors = this.cuentasService.validateCuenta(this.cuentaSelected)
    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    this.processing = true;
    this.cuentaSelected.activa = (this.cuentaSelected.activa)?1:0;
    this.cuentaSelected.balcasa = (this.cuentaSelected.balcasa)?1:0;
    this.cuentaSelected.kr = (this.cuentaSelected.kr)?1:0;
    this.cuentaSelected.fechaInicio = $('#fechaInicio').val();

    this.cuentasService.createCuenta(this.cuentaSelected)
      .subscribe(response => {
        const respuesta = response.json();
        this.processing = false;
        if (respuesta.success) {
          this.successModal.open({
            'title': '¡Éxito!',
            'description': 'Se ha creado correctamente la cuenta'
          });
          this.cuentaSelected.idCuentas = respuesta.content.id;
          this.goPage(1);
        }
      }, error => {
        this.processing = false;

        // resolviendo errores 403 y 500. sin notifications
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400) {
          this.setBackendErrors(error.json().content);
        }

        if (error.status == 400 || error.status == 500) {
          this.errorModal.open({
            'title': 'Error',
            'description': "No se ha podido guardar la cuenta, inténtelo más tarde"
          });
        }
      });
  }

  setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  cuentaSelectedWithId() {
    if (! this.cuentaSelected) {
      return false;
    }
    return (this.validatorService.required(this.cuentaSelected.idCuentas));
  }

  writePermission() {
    return this.cuentasService.writePermission();
  }

  canExport() {
    return this.cuentasService.canExport();
  }

  canSecurity() {
    return this.cuentasService.canSecurity();
  }

  habilitarCuenta(cuenta) {

    const title = (cuenta.activa == 1) ? 'Desactivar' : 'Activar';
    const body = (cuenta.activa == 1) ? 'desactivar' : 'activar';

    this.warningModal.open({
      'title': title + ' la cuenta',
      'description': 'No se puede ' + body + '  la cuenta',
    });
    return false;
  }

  cancelarCuentaSelected() {
    this.confirmModal.open({
      'title': 'Cancelar Cambios',
      'description': '¿Está seguro que desea cancelar estos cambios?',
      'callback': this.resetCuentaSelected
    });
  }

  securityModule() {
    if (!this.securityActived) {
      this.securityModal.open();
    } else {
      this.authService.closeKey()
        .subscribe((response) => {
          const respuesta = response.json();
          if (respuesta.success) {
            this.securityActived = false;
            this.tiposCuentas = this.cuentasService.getCuentasTipos(this.securityActived);
            this.goPage(1);
            this.resetCuentaSelected();
          }
        }, (error) => {
          // resolviendo errores 403 y 500. sin notifications
          this.helperService.httpGlobalError(error, false);
        });
    }
  
  }

  checkSecurityKey(password) {
    this.securityModal.loading = true;
    this.cuentasService.activeSecurityModule(password)
      .subscribe((response) => {
        const respuesta = response.json();
        this.securityModal.loading = false;
        if(respuesta.success === true) {
          this.goPage(1);
          this.securityActived = true;
          this.tiposCuentas = this.cuentasService.getCuentasTipos(this.securityActived);
          this.securityModal.close();
          this.resetCuentaSelected();
        }
      }, (error) => {
        this.securityModal.loading = false;
        this.helperService.httpGlobalError(error, false);
        this.securityModal.lock();
        this.securityActived = false;
      })
  }

  // MODAL FUNCTIONS

  modalCallback(callback) {
    callback();
  }

  // MAIN SECTIONS FUNCTIONS 

  mainContainerClass(){
    return (this.mostrarListado)?"col-12":"offset-2 col-8";
  }

  mainTableClass(){
    return (this.mostrarListado)?"col-8":"col-4";
  }

  mainDetailsClass(){
    return (this.mostrarListado)?"col-4":"col-8";
  }

  startPaginate(content){
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for(let i = 1; i <= this.paginate.last_page; i++){
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }

  goPreviousPage(){
    this.goPage(this.paginate.current_page - 1)
  }

  goNextPage(){
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {
    if (this.searchText) {
      this.searchCuentas(page);
    } else {
      this.getCuentas(page);
    }

  }

  changeSwitchListado(){
    if (!this.mostrarListado){
      this.cuentaSelected = this.cuentasService.getDefaultSchedule();
    }
  }

  export() {
    this.exporting = true;
    this.cuentasService.export(this.searchText, this.filterByObra)
      .subscribe((response) => {
        this.exporting = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/catalogo-cuentas/catalogo-cuentas.component.ts